// shipping swiper slider

document.addEventListener('DOMContentLoaded', function() {
  let shippingswiper;

    function initshippingswiper() {
      $('.Shipping-inner-row').each(function() {
        var desktop = $(this).data("desktop");
        var large_tablet = $(this).data("large-tablet");
        var tablet = $(this).data("tablet");
        var mobile = $(this).data("mobile");
        var autoplay = $(this).data("autoplay");
        
      shippingswiper = new Swiper('.Shipping-inner-row', {
        slidesPerView: desktop,
        spaceBetween: 30,
        autoplay: autoplay,
        grabCursor: true,
        freeMode: false,
        mousewheel: false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: ".shipping-swiper-pagination",
          clickable: true,
        },
        breakpoints: {
          0: {
            slidesPerView: mobile
          },
          576: {
            slidesPerView: tablet
          },
          768: {
            slidesPerView: large_tablet
          },
          992: {
            slidesPerView: desktop
          }
        },
      });
    });
  }

  // Initialize shipping swiper on page load
  initshippingswiper();

  document.addEventListener('shopify:section:select', function() {
    // Reinitialize shipping swiper on section select
    initshippingswiper();
  });

  document.addEventListener('shopify:section:load', function() {
    // Reinitialize shipping swiper on section load
    initshippingswiper();
  });

  document.addEventListener('shopify:section:deselect', function() {
    // Cleanup shipping swiper on section deselect if necessary
    if (shippingswiper) {
      shippingswiper.destroy();
      shippingswiper = null;
    }
  });
});

// featured-collection swiper slider

 document.addEventListener('DOMContentLoaded', function() {
  var featuredCollectionSwiper;

  function initFeaturedCollectionSwiper() {
    $('.swiper-container.demo').each(function() {
      var enable = $(this).data("enable-slider"); 
      var desktop = $(this).data("desktop");
      var large_tablet = $(this).data("large-tablet");
      var tablet = $(this).data("tablet");
      var mobile = $(this).data("mobile");
      var autoplay = $(this).data("autoplay");
      var loop = $(this).data("loop");
      var speed = $(this).data("speed");
      
      if(enable){
        featuredCollectionSwiper = new Swiper('.swiper-container.demo', {
          slidesPerView: desktop,
          spaceBetween: 30,
          loop: true,
          autoplay: autoplay,
          loop: loop,
          speed: speed,
          dots:true,
           navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          pagination: {
            el: ".featured-swiper-pagination",
            clickable: true,
          },
          breakpoints: {
            320: {
              slidesPerView: mobile,
              spaceBetween: 15
            },
            480: {
              slidesPerView: tablet
            },
            641: {
              slidesPerView: large_tablet
            },
            768: {
              slidesPerView: large_tablet
            },
            992: {
              slidesPerView: desktop
            },
          },
        });
      } 
    });
  }

  // Initialize Featured Collection Swiper on page load
  initFeaturedCollectionSwiper();

  document.addEventListener('shopify:section:select', function() {
    // Reinitialize Featured Collection Swiper on section select
    initFeaturedCollectionSwiper();
  });

  document.addEventListener('shopify:section:load', function() {
    // Reinitialize Featured Collection Swiper on section load
    initFeaturedCollectionSwiper();
  });

  document.addEventListener('shopify:section:deselect', function() {
    // Cleanup Featured Collection Swiper on section deselect if necessary
    if (featuredCollectionSwiper) {
      featuredCollectionSwiper.destroy();
      featuredCollectionSwiper = null;
    }
  });
});

// testimonial swiper slider

document.addEventListener('DOMContentLoaded', function() {
  let testi;

  function initTestimonialSwiper() {
    $('.testimonial-wrap').each(function() {
      var desktop = $(this).data("desktop");
      var tablet = $(this).data("tablet");
      var mobile = $(this).data("mobile");
      var autoplay = $(this).data("autoplay");
      var loop = $(this).data("loop");
      var speed = $(this).data("speed");
      var freemode = $(this).data("freemode");
      var mousewheel = $(this).data("mousewheel");
      
      testi = new Swiper('.testimonial-wrap', {
        spaceBetween: 30,
        freeMode: freemode,
        loop: loop,
        speed: speed,
        autoplay: autoplay,
        mousewheel: mousewheel,
        navigation: {
          nextEl: ".testi-swiper-button-next",
          prevEl: ".testi-swiper-button-prev"
        },
        pagination: {
          el: '.testimonial-swiper-pagination',
             type: 'bullets',
          clickable:'true'
        },
        breakpoints: {
          320: {
            slidesPerView: mobile,
            spaceBetween: 15
          },
          480: {
            slidesPerView: mobile
          },
          576: {
            slidesPerView: mobile
          },
          768: {
            slidesPerView: tablet
          },
          992: {
            slidesPerView: desktop
          },
        }
      });
    });
  }

  // Initialize testimonial swiper on page load
  initTestimonialSwiper();

  document.addEventListener('shopify:section:select', function() {
    // Reinitialize testimonial swiper on section select
    initTestimonialSwiper();
  });

  document.addEventListener('shopify:section:load', function() {
    // Reinitialize testimonial swiper on section load
    initTestimonialSwiper();
  });

  document.addEventListener('shopify:section:deselect', function() {
    // Cleanup testimonial swiper on section deselect if necessary
    if (testi) {
      testi.destroy();
      testi = null;
    }
  });
});

// gallery swiper slider
document.addEventListener('DOMContentLoaded', function() {
    let galleryslider;
  
    function initGallerySwiper() {
      $('.gallery-swiper').each(function() {
        var autoplay = $(this).data("autoplay");
        var loop = $(this).data("loop");
        
        galleryslider = new Swiper('.gallery-swiper', {
          slidesPerView: "auto",
          centeredSlides: false,
          spaceBetween: 30,
          autoplay: autoplay,
          loop: loop,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          pagination: {
            el: ".gallery-swiper-pagination",
            clickable: true,
          }, 
        });
      });
    }
  
    // Initialize Gallery swiper on page load
    initGallerySwiper();
  
    document.addEventListener('shopify:section:select', function() {
      // Reinitialize Gallery swiper on section select
      initGallerySwiper();
    });

    document.addEventListener('shopify:section:load', function() {
      // Reinitialize Gallery swiper on section load
      initGallerySwiper();
    });
  
    document.addEventListener('shopify:section:deselect', function() {
      // Cleanup Gallery swiper on section deselect if necessary
      if (galleryslider) {
        galleryslider.destroy();
        galleryslider = null;
      }
    });
});

// tab-product swiper slider
document.addEventListener('DOMContentLoaded', function() {
  var tabswiper;

  function tabinitSwiper() {
    $('.swiper-container#lg-product-tab-slider').each(function() {
      var enable = $(this).data("enable-slider"); 
      var desktop = $(this).data("desktop");
      var large_tablet = $(this).data("large-tablet");
      var tablet = $(this).data("tablet");
      var mobile = $(this).data("mobile");
      var autoplay = $(this).data("autoplay");
      var loop = $(this).data("loop");
      var speed = $(this).data("speed");
      
      if(enable){
        tabswiper = new Swiper('.swiper-container#lg-product-tab-slider', {
          slidesPerView: 1,
          spaceBetween: 30,
          observer: true,
          observeParents: true,
          dots:true,
          loop: loop,
          speed: speed,
          autoplay: autoplay,
          pagination: {
            el: ".tab-swiper-pagination",
            clickable: true,
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          breakpoints: {
            320: {
              slidesPerView: mobile,
              spaceBetween: 15
            },
            576: {
              slidesPerView: tablet
            },
            641: {
              slidesPerView: large_tablet
            },
            990: {
              slidesPerView: desktop
            },
          },
        });
      }
    });
  }

  // Initialize Tab Swiper on page load
  tabinitSwiper();

  document.addEventListener('shopify:section:select', function() {
    // Reinitialize Tab Swiper on section select
    tabinitSwiper();
  });

  document.addEventListener('shopify:section:load', function() {
    // Reinitialize Tab Swiper on section load
    tabinitSwiper();
  });

  document.addEventListener('shopify:section:deselect', function() {
    // Cleanup Tab Swiper on section deselect if necessary
    if (tabswiper) {
      tabswiper.destroy();
      tabswiper = null;
    }
  });
});

// blog swiper slider

document.addEventListener('DOMContentLoaded', function() {
    let blog;
  
    function initBlogSwiper() {
      $('.swiper-slider-blog').each(function() {
        var desktop = $(this).data("desktop");
        var tablet = $(this).data("tablet");
        var mobile = $(this).data("mobile");
        var autoplay = $(this).data("autoplay");
        var loop = $(this).data("loop");
        var speed = $(this).data("speed");
        var freemode = $(this).data("freemode");
        var mousewheel = $(this).data("mousewheel");
        
        blog = new Swiper('.swiper-slider-blog', {
          slidesPerView: 1,
          grabCursor: true,
          freeMode: freemode,
          autoplay: autoplay,
          spaceBetween: 30,
          loop: loop,
          speed: speed,
          mousewheel: mousewheel,
          keyboard: {
            enabled: true
          },
          pagination: {
            el: ".blog-swiper-pagination",
            clickable: true,
          },
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
          },
          breakpoints: {
             320: {
              slidesPerView: mobile,
              spaceBetween: 15
            },
            480: {
              slidesPerView: mobile
            },
            576: {
              slidesPerView: mobile
            },
            768: {
              slidesPerView: tablet
            },
            992: {
              slidesPerView: desktop
            },
          }
        });
      });
    }
  
    // Initialize blog swiper on page load
    initBlogSwiper();
  
    document.addEventListener('shopify:section:select', function() {
      // Reinitialize blog swiper on section select
      initBlogSwiper();
    });

    document.addEventListener('shopify:section:load', function() {
      // Reinitialize blog swiper on section load
      initBlogSwiper();
    });
  
    document.addEventListener('shopify:section:deselect', function() {
      // Cleanup blog swiper on section deselect if necessary
      if (blog) {
        blog.destroy();
        blog = null;
      }
    });
  });

// instagram swiper slider
document.addEventListener('DOMContentLoaded', function() {
    let instagramSwiper;
  
    function initInstagramSwiper() {
      $('.main-instagram-post-section-wrapper').each(function() {
        var desktop = $(this).data("desktop");
        var large_tablet = $(this).data("large-tablet");
        var tablet = $(this).data("tablet");
        var mobile = $(this).data("mobile");
        var autoplay = $(this).data("autoplay");
        var loop = $(this).data("loop");
        var speed = $(this).data("speed");
        
        instagramSwiper = new Swiper('.main-instagram-post-section-wrapper', {
          slidesPerView: 1,
          spaceBetween: 30,
          autoplay: autoplay,
          grabCursor: true,
          freeMode: false,
          loop: loop,
          speed: speed,
          mousewheel: false,
           navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          pagination: {
            el: ".instagram-swiper-pagination",
            clickable: true,
          },
          breakpoints: {
            320: {
              slidesPerView: mobile,
              spaceBetween: 15
            },
            480: {
              slidesPerView: tablet
            },
            641: {
              slidesPerView: large_tablet
            },
            768: {
              slidesPerView: large_tablet
            },
            992: {
              slidesPerView: desktop
            },
          },
        });
      });
    }
  
    // Initialize Instagram swiper on page load
    initInstagramSwiper();
  
    document.addEventListener('shopify:section:select', function() {
      // Reinitialize Instagram swiper on section select
      initInstagramSwiper();
    });

    document.addEventListener('shopify:section:load', function() {
      // Reinitialize Instagram swiper on section load
      initInstagramSwiper();
    });
  
    document.addEventListener('shopify:section:deselect', function() {
      // Cleanup Instagram swiper on section deselect if necessary
      if (instagramSwiper) {
        instagramSwiper.destroy();
        instagramSwiper = null;
      }
    });
  });

// brand swiper slider

document.addEventListener('DOMContentLoaded', function() {
    let brand;
  
    function initBrandSwiper() {
       $('.brand-slider-section-wrapper').each(function() {
        var desktop = $(this).data("desktop");
        var large_tablet = $(this).data("large-tablet");
        var tablet = $(this).data("tablet");
        var mobile = $(this).data("mobile");
        var autoplay = $(this).data("autoplay");
        var loop = $(this).data("loop");
        var speed = $(this).data("speed");
         
        brand = new Swiper('.brand-slider-section-wrapper', {
          slidesPerView: 1,
          spaceBetween: 182,
          autoplay: autoplay,
          grabCursor: true,
          freeMode: false,
          loop: loop,
          speed: speed,
          mousewheel: false,
           navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          pagination: {
            el: ".brand-swiper-pagination",
            clickable: true,
          },
          breakpoints: {
            320: {
              slidesPerView: mobile,
              spaceBetween: 50
            },
            575: {
              slidesPerView: tablet,
              spaceBetween: 75
            },
            767: {
              slidesPerView: tablet,
              spaceBetween: 100
            },
            990: {
              slidesPerView: large_tablet,
              spaceBetween: 120
            },
            1199: {
              slidesPerView: large_tablet,
              spaceBetween: 150
            },
            1429: {
              slidesPerView: desktop,
            },
          }
        });
      });
    }
  
    // Initialize brand swiper on page load
    initBrandSwiper();
  
    document.addEventListener('shopify:section:select', function() {
      // Reinitialize brand swiper on section select
      initBrandSwiper();
    });

    document.addEventListener('shopify:section:load', function() {
      // Reinitialize brand swiper on section load
      initBrandSwiper();
    });
  
    document.addEventListener('shopify:section:deselect', function() {
      // Cleanup brand swiper on section deselect if necessary
      if (brand) {
        brand.destroy();
        brand = null;
      }
    });
  });

// category collection swiper slider

document.addEventListener('DOMContentLoaded', function() {
    let categoryswiper;
  
    function initcategoryswiper() {
      $('.main-collection-list-wrapper').each(function() {
        var desktop = $(this).data("desktop");
        var large_tablet = $(this).data("large-tablet")
        var tablet = $(this).data("tablet");
        var mobile = $(this).data("mobile");
        var autoplay = $(this).data("autoplay");
        var loop = $(this).data("loop");
        var speed = $(this).data("speed");
        
        categoryswiper = new Swiper('.main-collection-list-wrapper', {
          slidesPerView: 1,
          spaceBetween: 30,
          autoplay: autoplay,
          grabCursor: true,
          freeMode: false,
          speed: speed,
          loop: loop,
          mousewheel: false,
           navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          pagination: {
            el: ".category-swiper-pagination",
            clickable: true,
          },
          breakpoints: {
            320: {
              slidesPerView: mobile,
              spaceBetween: 15
            },
            480: {
              slidesPerView: mobile
            },
            576: {
              slidesPerView: tablet
            },
            768: {
              slidesPerView: large_tablet
            },
            992: {
              slidesPerView: desktop
            }
          },
        });
      });
    }
  
    // Initialize category swiper on page load
    initcategoryswiper();
  
    document.addEventListener('shopify:section:select', function() {
      // Reinitialize category swiper on section select
      initcategoryswiper();
    });
    
    document.addEventListener('shopify:section:load', function() {
      // Reinitialize category swiper on section load
      initcategoryswiper();
    });
  
    document.addEventListener('shopify:section:deselect', function() {
      // Cleanup category swiper on section deselect if necessary
      if (categoryswiper) {
        categoryswiper.destroy();
        categoryswiper = null;
      }
    });
  });

// main-collection-grid slider
  document.addEventListener('DOMContentLoaded', function() {
    let collectionswiper;
  
    function initcategoryswiper() {
      $('.collection_slider').each(function() {
        var enable = $(this).data("enable");
        var desktop = $(this).data("desktop");
        var large_tablet = $(this).data("large-tablet");
        var tablet = $(this).data("tablet");
        var mobile = $(this).data("mobile");
        var autoplay = $(this).data("autoplay");
        var loop = $(this).data("loop");
        var speed = $(this).data("speed");

        if(enable){
          collectionswiper = new Swiper('.collection_slider', {
            slidesPerView: 1,
            spaceBetween: 30,
            autoplay: autoplay,
            loop: loop,
            speed: speed,
            freeMode: false,
            mousewheel: false,
            pagination: {
              el: ".swiper-pagination",
              clickable: true,
            },
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
            breakpoints: {
              320: {
                slidesPerView: mobile,
                spaceBetween: 15
              },
              480: {
                slidesPerView: tablet
              },
              681: {
                slidesPerView: large_tablet
              },
              768: {
                slidesPerView: large_tablet
              },
              992: {
                slidesPerView: desktop
              }
            },
          });
        }
      });
    }
  
    // Initialize category swiper on page load
    initcategoryswiper();
  
    document.addEventListener('shopify:section:select', function() {
      // Reinitialize category swiper on section select
      initcategoryswiper();
    });
  
    document.addEventListener('shopify:section:deselect', function() {
      // Cleanup category swiper on section deselect if necessary
      if (collectionswiper) {
        collectionswiper.destroy();
        collectionswiper = null;
      }
    });
  });